<template>
  <div>
    <!-- Dialog for search results -->
    <v-dialog v-model="dialogResultados" max-width="1200px" persistent>
      <v-card>
        <v-card-title>
          <v-icon left>mdi-file-table</v-icon>
          Resultados de Procesamiento
          <v-spacer></v-spacer>
          <span v-if="procesamientos.length > 0" class="text-subtitle-1">
            Total: {{ procesamientos.length }} procesamiento(s)
          </span>
          <v-btn icon @click="cerrarResultados">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text v-if="procesamientos.length === 0 && !loading">
          <v-alert type="info" outlined>
            No se encontraron resultados con los filtros aplicados.
          </v-alert>
        </v-card-text>

        <v-card-text v-if="loading">
          <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
        </v-card-text>

        <v-card-text v-if="procesamientos.length > 0">
          <v-data-table
            :headers="headers"
            :items="procesamientos"
            :loading="loading"
            class="elevation-1"
            @click:row="abrirDetalle"
          >
            <template slot="item.status" slot-scope="{ item }">
              <v-chip
                :color="getStatusColor(item.status)"
                text-color="white"
                small
              >
                {{ getStatusText(item.status) }}
              </v-chip>
            </template>
            
            <template slot="item.inicioProcesado" slot-scope="{ item }">
              {{ formatearFecha(item.inicioProcesado) }}
            </template>
            
            <template slot="item.finProcesado" slot-scope="{ item }">
              {{ formatearFecha(item.finProcesado) }}
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <v-btn
                icon
                small
                color="primary"
                @click.stop="abrirDetalle(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions v-if="procesamientos.length > 0">
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="cerrarResultados">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de detalle -->
    <v-dialog v-model="dialogDetalle" max-width="600px">
      <v-card v-if="procesamientoSeleccionado">
        <v-card-title class="headline">
          <v-icon left>mdi-file-document</v-icon>
          Detalle del Procesamiento
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-card outlined>
                <v-card-subtitle>Información General</v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <strong>Nombre del Archivo:</strong><br>
                      {{ procesamientoSeleccionado.nombreArchivo }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Estado:</strong><br>
                      <v-chip
                        :color="getStatusColor(procesamientoSeleccionado.status)"
                        text-color="white"
                        small
                      >
                        {{ getStatusText(procesamientoSeleccionado.status) }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            
            <v-col cols="12">
              <v-card outlined>
                <v-card-subtitle>Estadísticas de Procesamiento</v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col cols="6" md="3">
                      <v-card color="blue lighten-5" flat>
                        <v-card-text class="text-center">
                          <div class="text-h4 blue--text">{{ procesamientoSeleccionado.totalRegistros }}</div>
                          <div class="text-caption">Total Registros</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-card color="green lighten-5" flat>
                        <v-card-text class="text-center">
                          <div class="text-h4 green--text">{{ procesamientoSeleccionado.registrosInsertados }}</div>
                          <div class="text-caption">Insertados</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-card color="red lighten-5" flat>
                        <v-card-text class="text-center">
                          <div class="text-h4 red--text">{{ procesamientoSeleccionado.registrosConError }}</div>
                          <div class="text-caption">Con Error</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-card color="orange lighten-5" flat>
                        <v-card-text class="text-center">
                          <div class="text-h4 orange--text">{{ calcularPorcentajeExito(procesamientoSeleccionado) }}%</div>
                          <div class="text-caption">Éxito</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card outlined>
                <v-card-subtitle>Fechas de Procesamiento</v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <strong>Inicio:</strong><br>
                      {{ formatearFecha(procesamientoSeleccionado.inicioProcesado) }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Fin:</strong><br>
                      {{ formatearFecha(procesamientoSeleccionado.finProcesado) }}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cerrarDetalle">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    procesamientos: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialogResultados: false,
      dialogDetalle: false,
      procesamientoSeleccionado: null,
      headers: [
        { text: 'Archivo', value: 'nombreArchivo' },
        { text: 'Estado', value: 'status' },
        { text: 'Total Registros', value: 'totalRegistros' },
        { text: 'Insertados', value: 'registrosInsertados' },
        { text: 'Con Error', value: 'registrosConError' },
        { text: 'Inicio', value: 'inicioProcesado' },
        { text: 'Fin', value: 'finProcesado' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ]
    };
  },

  methods: {
    mostrarResultados() {
      this.dialogResultados = true;
    },

    cerrarResultados() {
      this.dialogResultados = false;
    },

    abrirDetalle(item) {
      this.procesamientoSeleccionado = item;
      this.dialogDetalle = true;
    },

    cerrarDetalle() {
      this.dialogDetalle = false;
      this.procesamientoSeleccionado = null;
    },

    getStatusColor(status) {
      switch (status) {
        case 1:
          return 'orange';
        case 2:
          return 'blue';
        case 3:
          return 'green';
        default:
          return 'grey';
      }
    },

    getStatusText(status) {
      switch (status) {
        case 1:
          return 'Pendiente';
        case 2:
          return 'En Proceso';
        case 3:
          return 'Completado';
        default:
          return 'Desconocido';
      }
    },

    formatearFecha(fechaObj) {
      if (!fechaObj) return 'N/A';
      
      const dia = fechaObj.dayOfMonth.toString().padStart(2, '0');
      const mes = fechaObj.monthValue.toString().padStart(2, '0');
      const año = fechaObj.year;
      
      return `${dia}/${mes}/${año}`;
    },

    calcularPorcentajeExito(procesamiento) {
      if (procesamiento.totalRegistros === 0) return 0;
      return Math.round((procesamiento.registrosInsertados / procesamiento.totalRegistros) * 100);
    }
  }
};
</script>
